<div class="content-container">
    <img *ngFor="let item of imageList" [src]="item" alt="" style="width: 100%;">
</div>